import { Component, HostListener, Input, ChangeDetectionStrategy } from "@angular/core"

@Component({
  selector: "flow-button-v2",
  templateUrl: "./flow-button-v2.component.html",
  styleUrl: "./flow-button-v2.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlowButtonV2Component {
  @Input() label: string = ""
  @Input() buttonType: "button" | "submit" = "button"
  @Input() ariaLabel: string | null = ""
  @Input() icon: string | null = null
  @Input() disabled: boolean | null = false
  @Input() type: "primary" | "secondary" | "destructive" = "primary"
  @Input() width: string | null = "fit-content"
  @Input() iconLeft: boolean = true
  @Input() iconRight: string | null = null
  @Input() doubleIcon: boolean = false
  @Input() size: "small" | "medium" | "large" = "medium"
  @Input() noBorder: boolean = false
  @Input() loading: boolean | null = false
  @Input() ghostVersion: boolean = false
  @Input() imageSize: string = "12px"

  @HostListener("click", ["$event"])
  onHostClick(event: MouseEvent): void {
    if (this.disabled || this.loading) event.stopImmediatePropagation()
  }

  get isGhost(): boolean {
    return this.ghostVersion && !this.disabled
  }

  get loaderColor(): "light" | "dark" {
    if (this.isGhost) return "dark"
    return this.type === "secondary" ? "dark" : "light"
  }

  get loaderCustomColor(): string {
    if (!this.isGhost) return ""
    if (this.type === "primary") return "#4568d0"
    if (this.type === "destructive") return "#b91c1c"
    return "#18181b"
  }

  getWidth(): string {
    if (!!this.label) return this.width ?? "fit-content"
    else if (this.size === "small") return "32px"
    else if (this.size === "medium") return "40px"
    else return "48px"
  }
}
